import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _cloneDeep from "lodash/cloneDeep";
import _uniq from "lodash/uniq";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import analytics from '@nerdwallet/analytics';
import { setCookie, getJSONFromCookie } from '../../helpers/cookie-helpers';
import { logRemoval, logClearComparedCards } from '../../helpers/log-interaction';
import { CompareCardIdListCookieName, CompareCardDataCookieName, CompareCardRemovedLoopbackCookieName } from './cookie-names';
export var SET_FETCHING_CARD_DATA = 'CCCB_SET_FETCHING_CARD_DATA';
/**
 * Use this to signal status of a fetch from offer-api. This gives the value to isCompareCardsBusy.
 * @param {boolean} isFetching - true if we are fetching data now, false otherwise.
 * @return {Action} - An action of type SET_FETCHING_CARD_DATA.
 */

export var setFetchingCardData = function setFetchingCardData(isFetching) {
  return {
    type: SET_FETCHING_CARD_DATA,
    isFetching: isFetching
  };
};
export var REMOVE_CARD_FROM_COMPARE = 'REMOVE_CARD_FROM_COMPARE';

var removeCardFromCompare = function removeCardFromCompare(id) {
  return {
    type: REMOVE_CARD_FROM_COMPARE,
    id: id
  };
};

export var CLEAR_COMPARED_CARDS = 'CLEAR_COMPARED_CARDS';

var clearComparedCards = function clearComparedCards() {
  return {
    type: CLEAR_COMPARED_CARDS
  };
};

export var SET_COMPARED_CARD_IDS = 'SET_COMPARED_CARD_IDS';
export var setComparedCardIds = function setComparedCardIds(cardIds) {
  return {
    type: SET_COMPARED_CARD_IDS,
    cardIds: cardIds
  };
};
export var SET_COMPARED_CARD_DATA = 'SET_COMPARED_CARD_DATA';
export var setComparedCardData = function setComparedCardData(cards) {
  return {
    type: SET_COMPARED_CARD_DATA,
    cards: cards
  };
};
export var SET_COMPARED_CARD_IDS_AND_DATA = 'SET_COMPARED_CARD_IDS_AND_DATA';
export var setComparedCardIdsAndData = function setComparedCardIdsAndData(cardIds, cards) {
  return function (dispatch) {
    dispatch({
      type: SET_COMPARED_CARD_IDS,
      cardIds: cardIds
    });
    dispatch({
      type: SET_COMPARED_CARD_DATA,
      cards: cards
    });
  };
};
/**
 * Update CompareCardRemovedLoopbackCookieName with the given id(s). This will prevent this card-id
 * from being auto-added to the compare card from loopback data.
 *
 * @example
 * ```
 * // A single id.
 * blockLoopbackCardIDs(93053);
 *
 * // Multiple ids.
 * blockLoopbackCardIDs(93053, 93401, 93501, 93158);
 *
 * // A list of ids.
 * const arrOfIDs = [93053, 93401, 93501, 93158];
 * blockLoopbackCardIDs(...arrOfIDs);
 * ```
 *
 * @param {...number} newLoopbackCardIDsToBlock - vararg. Id to block.
 */

var blockLoopbackCardIDs = function blockLoopbackCardIDs() {
  var loopbackCardIDAlreadyBlocked = getJSONFromCookie(CompareCardRemovedLoopbackCookieName, []);

  for (var _len = arguments.length, newLoopbackCardIDsToBlock = new Array(_len), _key = 0; _key < _len; _key++) {
    newLoopbackCardIDsToBlock[_key] = arguments[_key];
  }

  var updatedListOfLoopbackCardIDsToBlock = _uniq([].concat(newLoopbackCardIDsToBlock, loopbackCardIDAlreadyBlocked));

  setCookie(CompareCardRemovedLoopbackCookieName, JSON.stringify(updatedListOfLoopbackCardIDsToBlock));
};
/**
 * Removes the card corresponding to the given id from compare, adds it to the loopback-blocklist
 * and returns a Promise. The promise is returned to make the api consistent with saveToCompare().
 *
 * @param {number} id - id of the target card.
 * @param {string} productLocation - for tracking with interaction event.
 * @returns {Promise} - promise that resolves into the card object that was removed.
 */


export var removeFromCompare = function removeFromCompare(id) {
  var productLocation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return function (dispatch, getState) {
    var cardsToCompare = getState().compareCards.cardsToCompare;

    var cardToRemove = _cloneDeep(cardsToCompare[id]);

    dispatch(removeCardFromCompare(id));
    logRemoval(cardToRemove, productLocation); // Update cookie with the new state

    var cardIDs = getState().compareCards.cardIDsToCompare;
    setCookie(CompareCardIdListCookieName, JSON.stringify(cardIDs));
    setCookie(CompareCardDataCookieName, JSON.stringify(getState().compareCards.cardsToCompare));
    blockLoopbackCardIDs(id);
    return Promise.resolve(cardToRemove);
  };
};
/**
 * Removes all the cards from compare and adds them to the loopback-blocklist and returns a
 * Promise. The promise is returned to make the api consistent with saveToCompare().
 *
 * @param {number} id - id of the target card.
 * @param {string} productLocation - for tracking with interaction event.
 * @returns {Promise} - promise that resolves into the card objects that were removed.
 */

export var clearCompareList = function clearCompareList(enableAnalytics, impressionId) {
  return function (dispatch, getState) {
    if (enableAnalytics && impressionId) {
      analytics.track("element_interacted", {
        action: "select",
        entity_name: "cc_add_to_compare_reset",
        impression_id: impressionId,
        interaction_type: "press"
      });
    }

    var newLoopbackCardIDsToBlock = getState().compareCards.cardIDsToCompare;
    var removedCards = getState().compareCards.cardsToCompare;
    dispatch(clearComparedCards());
    logClearComparedCards(); // Update cookie with the new state

    setCookie(CompareCardIdListCookieName, JSON.stringify(getState().compareCards.cardIDsToCompare));
    blockLoopbackCardIDs.apply(void 0, _toConsumableArray(newLoopbackCardIDsToBlock));
    return Promise.resolve(removedCards);
  };
};
//# sourceMappingURL=compare.js.map